import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Img from '../../../Img';
import { getApiAxiosInstance } from '../../../../utils/network';
import styles from '../collegeCoachActivity.scss';

const TARGET_COLLEGES_ENDPOINT = '/v1/cpp/target-colleges';
const ADD_ICON_SRC = '/img/v3/icons/icon-18px-circle-plus-teal.svg';

const AddToTargetListButton = ({
    clubId,
    onSuccess,
    onError,
    'data-testid': dataTestId,
}) => {
    const [isAdding, setIsAdding] = useState(false);
    const [isAdded, setIsAdded] = useState(false);

    const handleClick = async () => {
        if (!clubId || isAdding || isAdded) {
            return;
        }
        setIsAdding(true);
        try {
            await getApiAxiosInstance().post(TARGET_COLLEGES_ENDPOINT, { clubId });
            setIsAdded(true);
            if (onSuccess) {
                onSuccess(clubId);
            }
        } catch (err) {
            if (onError) {
                onError(err?.response?.data?.DisplayMessage || 'We couldn\'t add that college.');
            }
        } finally {
            setIsAdding(false);
        }
    };

    const isDisabled = isAdded || isAdding;

    return (
        <button
            type="button"
            className={styles.addButton}
            onClick={handleClick}
            disabled={isDisabled}
            aria-label={isAdded ? 'Already in target list' : 'Add to target list'}
            data-testid={dataTestId}
        >
            <Img
                src={ADD_ICON_SRC}
                alt=""
                className={styles.addIcon}
            />
        </button>
    );
};

AddToTargetListButton.defaultProps = {
    onSuccess: null,
    onError: null,
    'data-testid': null,
};

AddToTargetListButton.propTypes = {
    clubId: PropTypes.number.isRequired,
    onSuccess: PropTypes.func,
    onError: PropTypes.func,
    'data-testid': PropTypes.string,
};

export default AddToTargetListButton;
